module.exports = __webpack_public_path__ + "img/1-kilo-pink.ad497e6f.svg";